import { FileText, Folder, X } from 'lucide-react'
import { FileTypeIcon } from '../primitives/FileTypeIcon'

export interface ContextChipProps {
  label: string
  kind?: 'pool' | 'doc'
  onRemove?: () => void
}

export function ContextChip({ label, kind = 'pool', onRemove }: ContextChipProps) {
  const Icon = kind === 'pool' ? Folder : FileText
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-brand-50 px-2.5 py-1 text-xs font-medium text-brand-700">
      <Icon className="h-3 w-3" />
      {label}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Entfernen"
          className="text-brand-600/70 hover:text-brand-700"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  )
}

export interface AttachmentChipProps {
  name: string
  size?: string
  note?: string
  onRemove?: () => void
}

export function AttachmentChip({ name, size, note, onRemove }: AttachmentChipProps) {
  return (
    <div className="flex items-center gap-2.5 rounded-lg border border-neutral-200 px-2.5 py-2">
      <FileTypeIcon name={name} />
      <div className="min-w-0">
        <div className="truncate text-sm font-medium text-neutral-800">{name}</div>
        <div className="text-xs text-neutral-400">
          {[
            <span key="badge" className="font-semibold uppercase tracking-wide text-neutral-500">
              Lokal
            </span>,
            size,
            note,
          ]
            .filter(Boolean)
            .map((part, i) => (
              <span key={i}>
                {i > 0 && ' · '}
                {part}
              </span>
            ))}
        </div>
      </div>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label="Entfernen"
          className="ml-auto text-neutral-400 hover:text-neutral-600"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
